import { Component, inject } from '@angular/core';
import { AccountService, CreateTikTokAccountTikApiIn } from '../../services/account/account.service';
import { StorageService } from '../../services/storage/storage.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertAlreadyConnectedComponent } from '../connect/atoms/alert-already-connected/alert-already-connected.component';
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-enter-instagram',
  standalone: true,
  imports: [AlertAlreadyConnectedComponent, FormsModule],   
  templateUrl: './enter-instagram.component.html',
  styleUrl: './enter-instagram.component.scss'
})
export class EnterInstagramComponent {

  location: Location = inject(Location);
  accountService: AccountService = inject(AccountService);
  storageService: StorageService = inject(StorageService);
  router: Router = inject(Router);
  
  alreadyConnectedError: {
    title: string,
    icon: string,
    action: string,
  } | undefined;

  instagramHandle: string | undefined;
  errorMessage: string | undefined;

  fetchingAccount: boolean = false;

  connectInstagram() {
    if (!this.instagramHandle) {
      this.errorMessage = 'Please enter an Instagram handle';
    }

    const handle = (this.instagramHandle ?? '').trim();
    if (!handle) return;

    else {
      console.log('instagramHandle: ', handle);
      void this.sendInstagramHandle(handle);
    }
  }
  
  async sendInstagramHandle(instagram_handle: string) {
    this.fetchingAccount = true;

    const externalId = this.storageService.get('externalId');
    const businessId = this.storageService.get('businessId');

    const body: CreateTikTokAccountTikApiIn = {
      externalId: externalId!,
      businessId: businessId!,
      handle: instagram_handle!
    }

    try {
      const createInstagramAccount_response = await firstValueFrom(this.accountService.createInstagramAccount(body))
      console.log('Create Instagram account Apify response: ', createInstagramAccount_response);
      this.accountService.enterInstagram = createInstagramAccount_response;
      this.fetchingAccount = false;
      this.router.navigate(['/enter-instagram-complete']);
    } catch (createTikTokAccountTikApi_error) {
      console.error('Error creating TikTok account: ', createTikTokAccountTikApi_error);
      this.fetchingAccount = false;
      this.errorMessage = 'Error creating TikTok account';
    }
  }


  goBack() {
    this.location.back();
  }
}
